import Row from '@components/Row';
import DecreaseIcon from '@components/Stepper/DecreaseIcon';
import IncreaseIcon from '@components/Stepper/IncreaseIcon';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useMemo } from 'react';

import styles from './styles.module.scss';

interface Props {
    value: number;
    increase: () => void;
    decrease: () => void;
    min?: number;
    max?: number;
    size?: 'small' | 'medium';
    disabled?: boolean;
}

function Stepper(props: Props) {
  const {
    value, min, max, size = 'medium', increase, decrease, disabled,
  } = props;
  const handleIncrease = () => {
    if (max !== undefined && value >= max) {
      return;
    }
    increase();
  };
  const handleDecrease = () => {
    if (min !== undefined && value <= min) {
      return;
    }
    decrease();
  };
  const decreaseDisabled = useMemo(() => disabled || (min !== undefined && value <= min), [disabled, min, value]);
  const increaseDisabled = useMemo(() => disabled || (max !== undefined && value >= max), [disabled, max, value]);
  const iconSize = size === 'small' ? 20 : 24;
  return <Row align='center'
                justify='space-between'
              // spacing={36}
              // spacing={8}
              className={`${styles.container} ${styles[`size-${size}`]}`} >
      <DecreaseIcon onClick={handleDecrease}
                    cursor='pointer'
                    size={20}
                    color={colors.gray5}/>
        {/*
        <Icon name={`amount_minus${decreaseDisabled ? '_disabled' : ''}`}
              size={iconSize}
              onClick={handleDecrease} /> */}
        <Text size={size === 'small' ? 'm' : 'lg'}
              fontWeight='bold'
              className={`${styles.value} ${styles[`size-${size}`]}`}
              color={colors.gray6} >
            {value}
        </Text>
      <IncreaseIcon onClick={handleIncrease}
                    cursor='pointer'
                    color={colors.gray5}
                    size={20} />
        {/*
        <Icon name={`amount_plus${increaseDisabled ? '_disabled' : ''}`}
              size={iconSize}
              onClick={handleIncrease} /> */}
    </Row>;
}

export default Stepper;
